import { useEffect } from "react";

type UseInfiniteScrollProps = {
    containerId: string;
    onLoadMore: () => void;
    hasMore: boolean;
    loading: boolean;
    enabled?: boolean;
    offset?: number; // How close to the bottom before triggering
};

export function useInfiniteScrollV2({
    containerId,
    onLoadMore,
    hasMore,
    loading,
    enabled = true,
    offset = 50,
}: UseInfiniteScrollProps) {
    useEffect(() => {
        if (!enabled) return;

        const element = document.getElementById(containerId);
        if (!element) return;

        const handleScroll = () => {
            if (loading || !hasMore) return;

            const { scrollTop, scrollHeight, clientHeight } = element;
            const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
            console.log({ distanceFromBottom, offset });
            if (distanceFromBottom <= offset) {
                onLoadMore();
            }
        };

        element.addEventListener("scroll", handleScroll);

        return () => {
            element.removeEventListener("scroll", handleScroll);
        };
    }, [containerId, onLoadMore, hasMore, loading, enabled, offset]);
}
